import { makeSimpleMapper } from "@/core/acl/mapperFactory";
import { zVehicleModelSchemaDom, zVehicleModelSchemaCreateDom, zVehicleModelSearchViewSchema, } from "@/types/vehicleModel/vehicleModel.domain";
import { zVehicleModelSchemaDto, zVehicleModelSchemaCreateDto, } from "@/types/vehicleModel/vehicleModel.dto";
const baseMapper = makeSimpleMapper({
    dtoToDomain: (dto) => zVehicleModelSchemaDom.parse({
        ...dto,
        usableBatterySize: dto.usable_battery_size,
        dcPorts: dto.dc_ports,
        vehicleType: dto.vehicle_type,
        releaseYear: dto.release_year,
        releaseMonth: dto.release_month,
        dcMaxPower: dto.dc_max_power,
        dcChargingCurve: dto.dc_charging_curve,
        dcIsDefaultChargingCurve: dto.dc_is_default_charging_curve,
        manufacturerId: dto.manufacturer_id,
    }),
    domainToDto: (domain) => zVehicleModelSchemaDto.parse({
        ...domain,
        usable_battery_size: domain.usableBatterySize,
        dc_ports: domain.dcPorts,
        vehicle_type: domain.vehicleType,
        release_year: domain.releaseYear,
        release_month: domain.releaseMonth,
        dc_max_power: domain.dcMaxPower,
        dc_charging_curve: domain.dcChargingCurve,
        dc_is_default_charging_curve: domain.dcIsDefaultChargingCurve,
        manufacturer_id: domain.manufacturerId,
    }),
    dtoToCreateDto: (domain) => zVehicleModelSchemaCreateDto.parse({
        ...domain,
        usable_battery_size: domain.usableBatterySize,
        dc_ports: domain.dcPorts,
        vehicle_type: domain.vehicleType,
        release_year: domain.releaseYear,
        release_month: domain.releaseMonth,
        dc_max_power: domain.dcMaxPower,
        dc_charging_curve: domain.dcChargingCurve,
        dc_is_default_charging_curve: domain.dcIsDefaultChargingCurve,
        manufacturer_id: domain.manufacturerId,
    }),
    dtoToCreateDom: (dto) => zVehicleModelSchemaCreateDom.parse({
        ...dto,
        usableBatterySize: dto.usable_battery_size,
        dcPorts: dto.dc_ports,
        vehicleType: dto.vehicle_type,
        releaseYear: dto.release_year,
        releaseMonth: dto.release_month,
        dcMaxPower: dto.dc_max_power,
        dcChargingCurve: dto.dc_charging_curve,
        dcIsDefaultChargingCurve: dto.dc_is_default_charging_curve,
        manufacturerId: dto.manufacturer_id,
    }),
});
export const VehicleModelMapper = {
    ...baseMapper,
    toSearchData: (dto) => {
        return zVehicleModelSearchViewSchema.parse(dto);
    },
};
